// @flow
import { useEffect, useState } from 'preact/hooks';
import { useErrorModalContextDispatch } from '../../../storeProviders/errorModalStore';
import type { ErrorResponseType } from '../../../api/controllers/checkoutController';
import { CheckoutApiErrorCodes } from '../../../api/controllers/checkoutController';
import type { ErrorModalType } from '../../../storeProviders/errorModalStore';
import { useCheckoutDispatchContext } from '../../../storeProviders/checkoutWidgetStore';
import { route } from 'preact-router';
import { checkoutInitRoute } from '../../../alias/checkoutWidgetRoutes';
import { useCheckoutTracker } from '../tracker';

type CheckoutErrorModalType = {
  ...ErrorResponseType,
  errorModal?: ErrorModalType,
};

export default function useCheckoutErrorModal() {
  const [_error, setCheckoutErrorModal]: [
    CheckoutErrorModalType,
    (CheckoutErrorModalType) => CheckoutErrorModalType,
  ] = useState();
  const checkoutTracker = useCheckoutTracker();

  const [checkoutError, setCheckoutError] = useState();

  const errorModalDispatch = useErrorModalContextDispatch();
  const checkoutDispatch = useCheckoutDispatchContext();

  const handleCheckoutError = (error: CheckoutErrorModalType) => {
    if (
      [
        CheckoutApiErrorCodes.INVALID_AIVF,
        CheckoutApiErrorCodes.INVALID_OTP,
      ].includes(error.errorCode)
    ) {
      checkoutTracker.trackError('ec_pv_payment_error', undefined, {
        fail_reason: (error.title || '') + ' ' + (error.message || ''),
        error_code: error.errorCode,
      });
      setCheckoutError(error);
      errorModalDispatch({
        type: 'MODAL/CLOSE',
      });
      return;
    }
    errorModalDispatch({
      type: 'MODAL/OPEN',
      payload: {
        title: error.title || 'Error',
        errorCode: error.errorCode,
        message:
          error.message ||
          'Sorry, we are experiencing technical difficulties & are working to fix them. Please try again later.',
        ...(error.isOrderRetryable && { isRetryAllowed: true }),
        onRetryClick: () => {
          if (error.isNtbError) {
            errorModalDispatch({
              type: 'MODAL/CLOSE',
            });
          } else {
            route(checkoutInitRoute.path, true);
          }
        },
        handleClose: () => {
          const { payload, signature } = error.callbackData || {};
          checkoutDispatch({
            type: 'SEND_MESSAGE',
            payload: {
              actionName: 'onTransactionComplete',
              payload: payload,
              signature: signature,
            },
          });
        },
        hideCloseButton:
          !!error.errorModal && !!error.errorModal.hideCloseButton,
      },
    });
  };

  useEffect(() => {
    if (_error) handleCheckoutError(_error);
  }, [_error]);

  return { setCheckoutErrorModal, checkoutError };
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/hooks/useCheckoutError.js